import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
export default class EditorEvents extends Plugin {
    init() {
        const editor = this.editor;
        const viewDocument = editor.editing.view.document;

        viewDocument.on("focus", () => this.handleResize());
        viewDocument.on("blur", () => this.handleResize());
        viewDocument.on("change:isFocused", () => this.handleResize());

        viewDocument.on("keydown", () => this.handleResize());
        viewDocument.on("keyup", () => this.handleResize());

        viewDocument.on("mousedown", () => this.handleResize());
        viewDocument.on("mouseup", () => this.handleResize());

        viewDocument.on("click", () => this.handleResize());
    }

    handleResize() {
        const editor = this.editor;
        const editableElement = editor.ui.view.editable.element;
        const editorHeight = editableElement.offsetHeight;

        editor.editing.view.change(writer => {
            writer.setStyle("height", `${editorHeight}px`, editor.editing.view.document.getRoot());
        });
    }
}
